import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { News } from 'src/app/core/models/news';
import { NewsService } from 'src/app/core/services/news.service';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
})
export class NewsDetailsComponent implements OnInit, OnDestroy {
  news?: News;

  otherNews: News[] = [];
  currentLang: string = 'en-US';

  translatedMetadata:
    | {
        title?: string;
        category?: string;
        plain_content?: string;
        bullets?: string;
        picture?: string;
      }
    | undefined;
  translatedContent: string | undefined;

  private langChangeSubscription: Subscription | undefined;

  constructor(
    private newsService: NewsService,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService
  ) {}

  async ngOnInit(): Promise<void> {
    this._getCurrentLang();

    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      () => {
        this._getCurrentLang();
        this.applyTranslation(this.translateService.currentLang);
      }
    );

    const newsId = this.route.snapshot.paramMap.get('id');
    if (newsId) {
      this.news = await this.newsService.get(newsId);
      this.applyTranslation(this.translateService.currentLang);
      const newsBatch: News[] = await this.newsService.getByRelevance(4);
      this.otherNews = newsBatch.filter((e) => e.id != newsId);

    }
  }

  ngOnDestroy(): void {
    this.langChangeSubscription?.unsubscribe();
  }

  private applyTranslation(lang: string): void {
    if (!this.news?.translations) {
      this.translatedMetadata = undefined;
      this.translatedContent = undefined;
      return;
    }

    const translation = this.news.translations[lang as 'pt' | 'en'];
    this.translatedMetadata = translation?.metadata;
    this.translatedContent = translation?.content;
  }

  private _getCurrentLang() {
    this.currentLang =
      this.translateService.currentLang.toLowerCase() == 'pt'
        ? 'pt-BR'
        : 'en-US';
  }

  goToNews(news: News) {
    if (news.metadata.link) {
      window.location.href = news.metadata.link;
    } else {
      this.router.navigate([`client/news/${news.id}`]);
    }
  }
}
